import React from "react";
import { useField } from "formik";
import FieldError from "./FieldError";

const FormikTextField = ({ label, required = false, ...props }) => {
  const [field, meta] = useField(props.name);
  const errorId = `${props.name}-error`;
  const hasError = Boolean(meta.touched && meta.error);

  return (
    <div className="form-group registration-field">
      {label && (
        <label htmlFor={props.name}>
          {label} {required && <span aria-hidden="true">*</span>}
        </label>
      )}
      <input
        {...field}
        {...props}
        id={props.name}
        className={`form-control${hasError ? " is-invalid" : ""}`}
        aria-invalid={hasError}
        aria-describedby={hasError ? errorId : undefined}
      />
      <FieldError id={errorId} error={meta.error} touched={meta.touched} />
    </div>
  );
};

export default FormikTextField;
